import { render, staticRenderFns } from "./ServiceJoinStep1Contentsogvtn.vue?vue&type=template&id=2f696714"
import script from "./ServiceJoinStep1Contentsogvtn.vue?vue&type=script&lang=js"
export * from "./ServiceJoinStep1Contentsogvtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f696714')) {
      api.createRecord('2f696714', component.options)
    } else {
      api.reload('2f696714', component.options)
    }
    module.hot.accept("./ServiceJoinStep1Contentsogvtn.vue?vue&type=template&id=2f696714", function () {
      api.rerender('2f696714', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/common/ServiceJoinStep1Contentsogvtn.vue"
export default component.exports